import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Users", -1);
var _hoisted_2 = {
  "class": "flex items-center justify-between mb-6"
};
var _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700"
}, "Role:", -1);
var _hoisted_4 = /*#__PURE__*/_createElementVNode("option", {
  value: null
}, null, -1);
var _hoisted_5 = /*#__PURE__*/_createElementVNode("option", {
  value: "user"
}, "User", -1);
var _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  value: "owner"
}, "Owner", -1);
var _hoisted_7 = [_hoisted_4, _hoisted_5, _hoisted_6];
var _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  "class": "block mt-4 text-gray-700"
}, "Trashed:", -1);
var _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  value: null
}, null, -1);
var _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  value: "with"
}, "With Trashed", -1);
var _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  value: "only"
}, "Only Trashed", -1);
var _hoisted_12 = [_hoisted_9, _hoisted_10, _hoisted_11];
var _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Create", -1);
var _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  "class": "hidden md:inline"
}, " User", -1);
var _hoisted_15 = {
  "class": "bg-white rounded-md shadow overflow-x-auto"
};
var _hoisted_16 = {
  "class": "w-full whitespace-nowrap"
};
var _hoisted_17 = /*#__PURE__*/_createElementVNode("tr", {
  "class": "text-left font-bold"
}, [/*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Name"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Email"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6",
  colspan: "2"
}, "USER TYPE")], -1);
var _hoisted_18 = {
  "class": "border-t"
};
var _hoisted_19 = ["src"];
var _hoisted_20 = {
  "class": "border-t"
};
var _hoisted_21 = {
  "class": "border-t"
};
var _hoisted_22 = /*#__PURE__*/_createTextVNode("ADMIN");
var _hoisted_23 = /*#__PURE__*/_createTextVNode("DGM");
var _hoisted_24 = /*#__PURE__*/_createTextVNode("SBU HEAD");
var _hoisted_25 = /*#__PURE__*/_createTextVNode("TEAM LEAD");
var _hoisted_26 = {
  "class": "w-px border-t"
};
var _hoisted_27 = {
  key: 0
};
var _hoisted_28 = /*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-4 border-t",
  colspan: "4"
}, "No users found.", -1);
var _hoisted_29 = [_hoisted_28];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_search_filter = _resolveComponent("search-filter");
  var _component_Link = _resolveComponent("Link");
  var _component_icon = _resolveComponent("icon");
  var _component_sapn = _resolveComponent("sapn");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Users"
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_search_filter, {
    modelValue: $data.form.search,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.form.search = $event;
    }),
    "class": "mr-4 w-full max-w-md",
    onReset: $options.reset
  }, {
    "default": _withCtx(function () {
      return [_hoisted_3, _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return $data.form.role = $event;
        }),
        "class": "form-select mt-1 w-full"
      }, _hoisted_7, 512), [[_vModelSelect, $data.form.role]]), _hoisted_8, _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return $data.form.trashed = $event;
        }),
        "class": "form-select mt-1 w-full"
      }, _hoisted_12, 512), [[_vModelSelect, $data.form.trashed]])];
    }),
    _: 1
  }, 8, ["modelValue", "onReset"]), _createVNode(_component_Link, {
    "class": "btn-indigo",
    href: "/users/create"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_13, _hoisted_14];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_15, [_createElementVNode("table", _hoisted_16, [_hoisted_17, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.users, function (user) {
    return _openBlock(), _createElementBlock("tr", {
      key: user.id,
      "class": "hover:bg-gray-100 focus-within:bg-gray-100"
    }, [_createElementVNode("td", _hoisted_18, [_createVNode(_component_Link, {
      "class": "flex items-center px-6 py-4 focus:text-indigo-500",
      href: "/users/".concat(user.id, "/edit")
    }, {
      "default": _withCtx(function () {
        return [user.photo ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          "class": "block -my-2 mr-2 w-5 h-5 rounded-full",
          src: user.photo
        }, null, 8, _hoisted_19)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(user.name) + " ", 1), user.deleted_at ? (_openBlock(), _createBlock(_component_icon, {
          key: 1,
          name: "trash",
          "class": "flex-shrink-0 ml-2 w-3 h-3 fill-gray-400"
        })) : _createCommentVNode("", true)];
      }),
      _: 2
    }, 1032, ["href"])]), _createElementVNode("td", _hoisted_20, [_createVNode(_component_Link, {
      "class": "flex items-center px-6 py-4",
      href: "/users/".concat(user.id, "/edit"),
      tabindex: "-1"
    }, {
      "default": _withCtx(function () {
        return [_createTextVNode(_toDisplayString(user.email), 1)];
      }),
      _: 2
    }, 1032, ["href"])]), _createElementVNode("td", _hoisted_21, [_createVNode(_component_Link, {
      "class": "flex items-center px-6 py-4",
      href: "/users/".concat(user.id, "/edit"),
      tabindex: "-1"
    }, {
      "default": _withCtx(function () {
        return [user.user_type == 'admin' ? (_openBlock(), _createBlock(_component_sapn, {
          key: 0
        }, {
          "default": _withCtx(function () {
            return [_hoisted_22];
          }),
          _: 1
        })) : _createCommentVNode("", true), user.user_type == 'dgm' ? (_openBlock(), _createBlock(_component_sapn, {
          key: 1
        }, {
          "default": _withCtx(function () {
            return [_hoisted_23];
          }),
          _: 1
        })) : _createCommentVNode("", true), user.user_type == 'sbu_head' ? (_openBlock(), _createBlock(_component_sapn, {
          key: 2
        }, {
          "default": _withCtx(function () {
            return [_hoisted_24];
          }),
          _: 1
        })) : _createCommentVNode("", true), user.user_type == 'team_lead' ? (_openBlock(), _createBlock(_component_sapn, {
          key: 3
        }, {
          "default": _withCtx(function () {
            return [_hoisted_25];
          }),
          _: 1
        })) : _createCommentVNode("", true)];
      }),
      _: 2
    }, 1032, ["href"])]), _createElementVNode("td", _hoisted_26, [_createVNode(_component_Link, {
      "class": "flex items-center px-4",
      href: "/users/".concat(user.id, "/edit"),
      tabindex: "-1"
    }, {
      "default": _withCtx(function () {
        return [_createVNode(_component_icon, {
          name: "cheveron-right",
          "class": "block w-6 h-6 fill-gray-400"
        })];
      }),
      _: 2
    }, 1032, ["href"])])]);
  }), 128)), $props.users.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_27, _hoisted_29)) : _createCommentVNode("", true)])])]);
}